import '../ACAD/ACAD.scss';

import {PageManager} from 'genesis-packages/core';

export default class ACED extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

};
